<!-- 大屏左侧设备类型统计卡片 -->
<template>
    <div class="box">
        <div class="tTitle">
            <div class="fTitleBorderTop"></div>
            设备类型统计
        </div>
        <!-- <dv-active-ring-chart :config="config" style="width:300px;height:300px" /> -->
        <div class="deviceStatusContent" ref="canva5"></div>
        <devicelistbox v-if="deviceListShow" :data="deviceTypeArrData" @deviceDeatil="goDeviceDetail"
            @close="deviceListShow = false"></devicelistbox>

        <devicedeatil v-if="deviceDeatilShow" :deviceData="checkDeviceDetail" @close="deviceDeatilShow = false">
        </devicedeatil>
    </div>
</template>

<script>
import devicelistbox from '@/components/common/maxWeb/devicelistbox.vue';
import devicedeatil from '@/components/common/maxWeb/devicedeatil.vue';
export default {
    name: 'leftcard2',
    data() {
        return {
            config: {
                data: [
                    {
                        name: '周口',
                        value: 55
                    },
                    {
                        name: '南阳',
                        value: 120
                    },
                    {
                        name: '西峡',
                        value: 78
                    },
                    {
                        name: '驻马店',
                        value: 66
                    },
                    {
                        name: '新乡',
                        value: 80
                    }
                ],
            },
            deviceListShow: false,
            deviceTypeArrData: [],
            // 选中的设备详情
            checkDeviceDetail: null,
            // 是否打开设备详情卡片
            deviceDeatilShow: false
        };
    },
    mounted() {
        this.leftcard();
    },
    components: {
        devicelistbox,
        devicedeatil
    },
    methods: {
        // 打开设备详情卡片
        goDeviceDetail(e) {
            console.log('父组件');
            console.log(e);
            // this.deviceListShow = false;
            this.deviceDeatilShow = true;
            this.checkDeviceDetail = e;
        },
        // 计算设备类型
        deviceType() {
            let arr = [];

            arr = this.$store.state.deviceNowData.map((item) => {
                return item.deviceType;

            });

            let obj = {};

            for (let i = 0; i < arr.length; i++) {
                var item = arr[i];
                obj[item] = obj[item] + 1 || 1;
            }

            let computerData = [];
            for (const key in obj) {
                computerData.push({
                    name: key,
                    value: obj[key]
                });
            }
            let storeDeviceType = computerData.map((item) => {
                console.log(item, 'itemtiemtei');

                return item.name;
            });
            this.$store.commit('setDeviceTypeArr', storeDeviceType);

            let echartsData = [];
            computerData.forEach((item) => {
                switch (item.name) {
                    case '水位流速监测':
                        echartsData.push({
                            value: item.value,
                            name: item.name,
                            itemStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: '#40E0D0' // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: '#00CED1' // 100% 处的颜色
                                        }
                                    ],
                                    global: false // 缺省为 false
                                }
                            }
                        });
                        break;

                    case '智能井盖V2':
                        echartsData.push({
                            value: item.value,
                            name: item.name,
                            itemStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: '#62d2a2' // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: '#1fab89' // 100% 处的颜色
                                        }
                                    ],
                                    global: false // 缺省为 false
                                }
                            }
                        });
                        break;
                    case '智能井盖L3W':
                        echartsData.push({
                            value: item.value,
                            name: item.name,
                            itemStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: '#2aa7de' // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: '#15c9cb' // 100% 处的颜色
                                        }
                                    ],
                                    global: false // 缺省为 false
                                }
                            }
                        });
                        break;
                    case '不锈钢井盖':
                        echartsData.push({
                            value: item.value,
                            name: item.name,
                            itemStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: '#40E0D0' // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: '#00CED1' // 100% 处的颜色
                                        }
                                    ],
                                    global: false // 缺省为 false
                                }
                            }
                        });
                        break;
                    case '雨量监测':
                        echartsData.push({
                            value: item.value,
                            name: item.name,
                            itemStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: '#48D1CC' // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: '#AFEEEE' // 100% 处的颜色
                                        }
                                    ],
                                    global: false // 缺省为 false
                                }
                            }
                        });
                        break;
                    case '智能井盖':
                        echartsData.push({
                            value: item.value,
                            name: item.name,
                            itemStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: '#00BFFF' // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: '#1E90FF' // 100% 处的颜色
                                        }
                                    ],
                                    global: false // 缺省为 false
                                }
                            }
                        });
                        break;
                    case '智能井盖4G':
                        echartsData.push({
                            value: item.value,
                            name: item.name,
                            itemStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: '#00BFFF' // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: '#1E90FF' // 100% 处的颜色
                                        }
                                    ],
                                    global: false // 缺省为 false
                                }
                            }
                        });
                        break;
                    case '智能井盖V4':
                        echartsData.push({
                            value: item.value,
                            name: item.name,
                            itemStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: '#00BFFF' // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: '#1E90FF' // 100% 处的颜色
                                        }
                                    ],
                                    global: false // 缺省为 false
                                }
                            }
                        });
                        break;
                    case '积水监测':
                        echartsData.push({
                            value: item.value,
                            name: item.name,
                            itemStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: '#00BFFF' // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: '#1E90FF' // 100% 处的颜色
                                        }
                                    ],
                                    global: false // 缺省为 false
                                }
                            }
                        });
                        break;
                    case '雷达水位计':
                        echartsData.push({
                            value: item.value,
                            name: item.name,
                            itemStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: '#00BFFF' // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: '#1E90FF' // 100% 处的颜色
                                        }
                                    ],
                                    global: false // 缺省为 false
                                }
                            }
                        });
                        break;

                    default:
                        break;
                }
            });

            return echartsData;
        },
        leftcard() {
            let that = this;
            const echartsInit = this.$echarts.init(this.$refs.canva5);
            echartsInit.setOption({
                // legend: {
                //     top: 'top',
                //     textStyle: {
                //         color: '#fff'
                //     }
                // },
                tooltip: {
                    show: true,
                    borderColor: '#10a8ff',
                    backgroundColor: '#000',
                    textStyle: {
                        color: '#fff',
                        fontWeight: 'bold'
                    }
                },
                series: [
                    {
                        name: '设备类型',
                        type: 'pie',
                        radius: [50, 100],
                        center: ['50%', '50%'],
                        roseType: 'area',
                        itemStyle: {
                            borderRadius: 0
                        },
                        label: {
                            textBorderColor: 'none',
                            color: '#fff',
                            show: true
                        },
                        data: that.deviceType()
                    }
                ]
            });

            echartsInit.on('click', (e) => {
                console.log(e);
                //  筛选设备数据
                this.handleData(e.name);
                // 打开设备列表
                this.deviceListShow = true;
            });
        },

        handleData(e) {
            this.deviceTypeArrData = this.$store.state.deviceNowData.filter((item) => {
                return item.deviceType == e;
            });
        }
    }
};
</script>

<style lang="less" scoped>
.box {
    width: 100%;
    height: 100%;
    display: flex;

    .tTitle {
        width: 0.8rem;
        word-wrap: break-word;
        font-size: 0.4rem;
        font-weight: bold;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        padding: 0.1rem;
        border-right: 1px solid #14283e;
        background-color: #000;

        .fTitleBorderTop {
            width: 0.4rem;
            height: 0.1rem;
            background-color: #8c39cf;
        }
    }

    .deviceStatusContent {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding-bottom: 10px;
    }
}
</style>